import React, { useReducer } from 'react';

const initialState = {
    user: null,
};

export const UserContext = React.createContext();

const UserReducer = (state, action) => {
    switch (action.type) {
        case 'set_user':
            return {
                ...state,
                user: action.payload,
            };
        case 'reset_user':
            return {
                ...state,
                user: null,
            };
        default:
            return state;
    }
};

export const UserContextProvider = ({ children }) => {
    const [state, userDispatch] = useReducer(UserReducer, initialState);

    return (
        <UserContext.Provider value={{ user: state.user, userDispatch }}>
            {children}
        </UserContext.Provider>
    );
};

export const useUserContext = () => {
    const context = React.useContext(UserContext);
    if (context === undefined) {
        throw new Error('useUserContext must be used within a UserProvider');
    }
    return context;
};
